<template>
    <el-row class="cs-contentContainer">
        <el-col :span="4" class="cs-main-left-container">
            <navigator></navigator>
        </el-col>
        <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
            <div style="" class="cs-fullHeight cs-contentContainer-right">
                <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
                    <el-row>
                        <el-col>
                            <span class="cs-title">个人信息</span>
                            <el-row>
                                <el-col :span="18">
                                    <label> &nbsp; </label>
                                </el-col>
                            </el-row>
                            <el-row class="grid-content">
                                <el-row v-if="USERMANAGER.isAdmin">
                                    <el-col :span="4" class="text-right"><strong><label class="el-form-item__label float-right">&nbsp;</label></strong>
                                    </el-col>
                                    <el-col :span="8">&nbsp;</el-col>
                                    <el-col :span="10">
                                        <el-button type="primary" size="medium" @click="onGlobalSettingsClick">全局设置</el-button>
                                    </el-col>
                                </el-row>
                                <el-row v-if="USERMANAGER.isAdmin">
                                    <el-col :span="4" class="text-right"><strong><label class="el-form-item__label float-right">&nbsp;</label></strong>
                                    </el-col>
                                    <el-col :span="8">&nbsp;</el-col>
                                    <el-col :span="10">
                                        <el-button :loading="isResetTerm" type="primary" size="medium" @click="edit('term')">学期重置</el-button>
                                    </el-col>
                                </el-row>
                                <el-row v-if="USERMANAGER.isAdmin">
                                    <el-col :span="4" class="text-right"><strong><label class="el-form-item__label float-right">&nbsp;</label></strong>
                                    </el-col>
                                    <el-col :span="8">&nbsp;</el-col>
                                    <el-col :span="10">
                                        <el-button :loading="isResetTrainingTerm" type="primary" size="medium" @click="edit('trainingTerm')">职业培训学期重置</el-button>
                                  </el-col>
                                </el-row>
                                <el-row v-if="USERMANAGER.isAdmin">
                                    <el-col :span="4" class="text-right"><strong><label class="el-form-item__label float-right">&nbsp;</label></strong>
                                    </el-col>
                                    <el-col :span="8">&nbsp;</el-col>
                                    <el-col :span="10">
                                        <el-button :loading="isResetEnrollment" type="primary" size="medium" @click="edit('enrollment')">重置占位</el-button>
                                    </el-col>
                                </el-row>
                                <el-row v-if="USERMANAGER.isAdmin">
                                    <el-col :span="4" class="text-right"><strong><label class="el-form-item__label float-right">&nbsp;</label></strong>
                                    </el-col>
                                    <el-col :span="8">&nbsp;</el-col>
                                    <el-col :span="10">
                                        <el-button :loading="isResetTrainingEnrollment" type="primary" size="medium" @click="edit('trainingEnrollment')">重置职业培训占位</el-button>
                                    </el-col>
                                </el-row>
                                <el-row v-if="USERMANAGER.isAdmin">
                                    <el-col :span="4" class="text-right"><strong><label class="el-form-item__label float-right">&nbsp;</label></strong>
                                    </el-col>
                                    <el-col :span="8">&nbsp;</el-col>
                                    <el-col :span="10">
                                        <el-button :loading="isClearAliyunVideos" type="primary" size="medium" @click="clearAliyunVideos()">清理阿里云视频</el-button>
                                    </el-col>
                                </el-row>
                                <el-row>
                                   <el-col :span="18">
                                    <label> &nbsp; </label>
                                  </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="4" class="text-right"> <strong><label class="el-form-item__label float-right">密码：</label></strong>
                                    </el-col>
                                    <el-col :span="8"><label class="el-form-item__content" style="width:40px;" v-text="form.Password"></label></el-col>
                                    <el-col :span="10">
                                        <el-button type="primary" size="medium" @click="edit('password')">更改密码</el-button>
                                    </el-col>
                                </el-row>
                                <el-row>
                                  <el-col class="text-center">
                                    <a :href="mobileAppLink">下载Android App</a>
                                  </el-col>
                                </el-row>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-col>
        <el-dialog :close-on-click-modal="false" width="700px" :visible.sync="passwordEditorVisible" top="8vh">
             <password-editor :type="'changePassword'" v-on:closeEditor="onCloseEditor" v-on:saveSuccess="onSaveSuccess"></password-editor>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" width="600px" :visible.sync="resetTermComponentVisible" top="10vh">
             <resetTermComponent v-on:closeDialog="onCloseResetTermComponent" v-on:saveSuccess="onSaveSuccessResetTermComponent"></resetTermComponent>
        </el-dialog>
        <el-dialog title="选择学校" :center="true" :close-on-click-modal="false" width="600px" :visible.sync="selectUniversityVisible" v-if="selectUniversityVisible" top="10vh">
             <selectUniversity v-on:close="onSelectUniversityClose" v-on:save="onSelectUniversitySave"></selectUniversity>
        </el-dialog>
        <el-dialog title="选择学期" :center="true" :close-on-click-modal="false" width="600px" :visible.sync="selectTermVisible" v-if="selectTermVisible" top="10vh">
             <selectTerm v-on:close="onSelectTermClose" v-on:save="onSelectTermSave"></selectTerm>
        </el-dialog>
        <globalSettingsEditor ref="gsEditor" />
    </el-row>
</template>


<style lang="scss" scoped>
.cs-contentContainer {
  .grid-content {
    margin-top: 15px;
    .cs-schedule-buttonContainer {
      text-align: right;
    }

    .el-button{
      width: 180px;
    }
  }
  .cs-schedule-bottomButton {
    margin-top: 20px;
  }
}
</style>

<script>
import passwordEditor from "../../components/passwordEditor.vue";
import navigator from "../../components/navigator";
import resetTermComponent from "../../components/resetTrainingTerm.vue";
import selectUniversity from "../../components/selectUniversity.vue";
import selectTerm from "../../components/selectTerm.vue";

import Vue from "vue";
import { getStore, setStore } from "../../config/mUtils";
import { resetTerm, resetTrainingTerm, getMobileAppLink } from "../../service/common.service";
import { resetAdvanceEnrollment,resetTrainingAdvanceEnrollment } from "../../service/student.service";
import {
  cleanupVideosByTerm
} from "@/service/alibabaCloud.service";
import global_ from '../../core/global'

export default {
  data() {
    return {
      isResetEnrollment: false,
      passwordEditorVisible: false,
      resetTermComponentVisible:false,
      isResetTerm:false,
      isResetTrainingEnrollment: false,
      isResetTrainingTerm:false,
      form: {
        Password: "********",
      },
      selectUniversityVisible: false,
      mobileAppLink: "",
      isClearAliyunVideos: false,
      selectTermVisible: false
    };
  },
  components: {
    navigator,
    globalSettingsEditor: () => import("@/components/globalSettingsEditor"),
    passwordEditor,
    resetTermComponent,
    selectUniversity,
    selectTerm
  },
  created() {
    getMobileAppLink().then(result =>{
      if (!!result && result.success){
        this.mobileAppLink = result.data;
      }
    });
    this.initData();
  },
  methods: {
    onGlobalSettingsClick() {
      let {gsEditor} = this.$refs;
      if (!gsEditor) return;

      gsEditor.showDialog();
    },
    edit(type) {
      if (type === "term") {
        if (this.isResetTerm)
          return;
        //this.resetTermComponentVisible = true;
        this.$confirm("您确定要重置当前学期吗？重置后，当前学期数据都会归档不可用。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.isResetTerm = true;
            resetTerm().then(result => {
              if (result.success) {
                this.$message({
                    message: "学期重置成功！",
                    type: "success"
                  });
              } else {
                if (result.message) {
                  this.$message({
                    message: result.message,
                    showClose: true,
                    type: "warning",
                    duration:0
                  });
                 
                }
              }
              this.isResetTerm = false;
            });
          })
          .catch(() => {});
      } else if (type === "trainingTerm"){
        this.resetTermComponentVisible = true;
      } else if (type === "password") {
        this.passwordEditorVisible = true;
      } else if (type === "enrollment") {
        this.selectUniversityVisible = true;
        // if (this.isResetEnrollment)
        //     return;
        //   this.$confirm("您确定要重置当前学期的所有占位吗？重置后，当前学期的所有占位都会归零。", "提示", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   type: "warning"
        // })
        //   .then(() => {
        //     this.isResetEnrollment = true;
        //     resetAdvanceEnrollment().then(result => {
        //       if (result.success) {
        //         this.$message({
        //             message: "占位重置成功！",
        //             type: "success"
        //           });
        //       } else {
        //         if (result.message) {
        //           this.$message({
        //             message: result.message,
        //             type: "warning"
        //           });
                 
        //         }
        //       }
        //       this.isResetEnrollment = false;
        //     });
        //   })
        //   .catch(() => {
        //      this.isResetEnrollment = false;
        //   });
      }else if (type === "trainingEnrollment") {
          if (this.isResetTrainingEnrollment)
            return;
          this.$confirm("您确定要重置当前学期的所有职业培训占位吗？重置后，当前学期的所有职业培训占位都会归零。", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.isResetTrainingEnrollment = true;
            resetTrainingAdvanceEnrollment().then(result => {
              if (result.success) {
                this.$message({
                    message: "职业培训占位重置成功！",
                    type: "success"
                  });
              } else {
                if (result.message) {
                  this.$message({
                    message: result.message,
                    type: "warning"
                  });
                 
                }
              }
              this.isResetTrainingEnrollment = false;
            });
          })
          .catch(() => {
            this.isResetTrainingEnrollment = false;
          });
      }
    },
    initData(type) {
      // getStudent(getStore("user_student_id")).then(result => {

      // });
    },
    onCloseEditor(type) {
      if (type === "password") {
        this.passwordEditorVisible = false;
      }
    },
    onSaveSuccess(type) {
      this.initData(type);
    },
    onCloseResetTermComponent(){
      this.resetTermComponentVisible = false;
    },
    onSaveSuccessResetTermComponent(){

    },
    onSelectUniversityClose(){
      this.selectUniversityVisible = false;
    },
    onSelectUniversitySave(data){
      if (!!data && !!data.universityId){
        this.isResetEnrollment = true;
        let name = "(" + data.universityName + ")";
        if (!!data.advanceEnrollmentComment){
          name += ", 备注 (" + data.advanceEnrollmentComment+ ")";
        }
        resetAdvanceEnrollment(data.universityId, data.advanceEnrollmentComment).then(result => {
          if (result.success) {
            this.$message({
                message: "学校 "+name+" 的占位重置成功！",
                type: "success"
              });
          } else {
            if (result.message) {
              this.$message({
                message: result.message,
                type: "warning"
              });
              
            }
          }
          this.isResetEnrollment = false;
        });
      }
      this.selectUniversityVisible = false;
    },
    onSelectTermClose(){
      this.selectTermVisible = false;
    },
    onSelectTermSave(data){
      if (!!data && !!data.termId){
        this.isClearAliyunVideos = true;
        this.selectTermVisible = false;
        cleanupVideosByTerm(data.termId, data.removeYearCourse).then(result =>{
          if (result && result.success){
            this.$message({
              message: "学期 "+data.termName+" 的视频清理成功！",
              type: "success"
            });
          }else if (result.message){
            this.$message({
              message: result.message,
              type: "warning"
            });
          }
          this.isClearAliyunVideos = false;
        });
      }
    },
    clearAliyunVideos(){
      this.selectTermVisible = true;
    }
  }
};
</script>
 



// WEBPACK FOOTER //
// src/page/admin/profile.vue